import { getWindowsCommunicationBridgeInstance } from "./window-communication-bridge";
import { LoggingService } from "../../ServiceDesk/sdServices/loggingSvc";
import {
  WindowHeartbeatService,
  WindowStatus,
  unexpectedlyClosed,
  getInstance as heartbeatGetInstance
} from "./window-heartbeat-service";
import { windowStoredPollFlight, FlightInformation } from "./window-communication-bridge-flighting";
import { FlightingServiceImplementation } from "../../ServiceDesk/sdServices/flightingSvc";
import sdServicesModule from "../../ServiceDesk/sdServices/sdServicesModule";

// @ngInject
sdServicesModule
  .run((flightingService: FlightingServiceImplementation) => {
    let isInFrame = false;
    try {
      isInFrame = window != window.top;
    } catch (e) {
      console.error(e, "Frame Check Failed check for inconsistency");
    }

    if (!isInFrame) {
      // Make sure that we delete the flight information so WCB doesn't use out of data information until the flighting service responses
      window.localStorage.removeItem(windowStoredPollFlight);
    }
    flightingService.whenReady().then(() => {
      let isReceiveIndexedDBOn = flightingService.isFlightEnabled("WCB_receive_indexedDB");
      let eventingFlightInfo: FlightInformation = {
        increasedPollFrequency: flightingService.isFlightEnabled("WCB_increased_polling_freq"),
        relaxedTryWaitTime: flightingService.isFlightEnabled("WCB_relaxed_try_wait_time"),
        disableRetries: flightingService.isFlightEnabled("WCB_disable_polling_retries"),
        usePollingAndEventing: flightingService.isFlightEnabled("WCB_polling_and_eventing"),
        useLocalStorageWrapper: flightingService.isFlightEnabled("local_storage_wrapper"),
        useCachedLocalStorageKeys: !flightingService.isFlightEnabled("disable_cached_keys"),
        publishIndexedDB: isReceiveIndexedDBOn && flightingService.isFlightEnabled("WCB_publish_indexedDB"),
        useLocalStorageKeyApi: flightingService.isFlightEnabled("local_storage_get_api"),
        useOnlyEventing: flightingService.isFlightEnabled("WCB_only_eventing"),
        receieveIndexedDB: isReceiveIndexedDBOn
      };
      window.localStorage.setItem(windowStoredPollFlight, JSON.stringify(eventingFlightInfo));
    });
  }) // windowCommunicationBridgeService can be used outside of angular, adding a seperate registration
  .factory("windowCommunicationBridgeService", () => {
    return getWindowsCommunicationBridgeInstance();
  })
  .factory("windowsHeartbeatService", () => heartbeatGetInstance())
  .run((windowsHeartbeatService: WindowHeartbeatService, loggingService: LoggingService) => {
    /** Note; do not remove as this run block ensures the windowsHeartbeatService is running at the start ServiceDesk */

    windowsHeartbeatService.registerStatusCallback((windowstatus: WindowStatus[]) => {
      let unexpectedlyClosedWindows = windowstatus.filter((window) => window.status == unexpectedlyClosed);
      if (unexpectedlyClosedWindows.length) {
        loggingService.logWarning(`Found ${unexpectedlyClosedWindows.length} abandoned heartbeat(s).`);
      }
    });
  });
let eventModule = angular.module("sdEventModule");
export default eventModule;
